import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles(
  (theme: Theme) => ({
    title: {
      //marginLeft: theme.spacing(1),
      //marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      fontSize: 25,
      color: 'black',
    },
    licenseInfoTitle: {
      width: `calc(100% - ${theme.spacing(3)}px)`,
      marginLeft: theme.spacing(1.5),
      marginTop: theme.spacing(0.5),
      //height: 39,
      fontSize: 16,
      //textTransform: 'uppercase',
      //lineHeight: '32px',
      //letterSpacing: 1,
    },
    paper: {
      marginTop: theme.spacing(10),
      padding: theme.spacing(2),
    },
    button: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(0.5),
      padding: theme.spacing(1, 3.5),
      marginRight: theme.spacing(1),
      height: 39,
      width: '100%',
      textTransform: 'none',
      letterSpacing: 0.15,
      fontSize: 14,
    },
    textField: {
      width: '100%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      //margin: theme.spacing(1),
    },
    select: {
      width: '100%',
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(1),
      //margin: theme.spacing(1),
    },
    formWraper: {
      marginTop: theme.spacing(2),
    },
    btnBox: {
      display: 'flex',
      justifyContent: 'flex-start',
      marginTop: theme.spacing(3),
    },
  }),
  {
    index: 1,
  }
);
